import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {PageEventInterface} from "@core/interfaces/page-event.interface";
import {TabManagementService} from "@core-services/tab-management.service";
import {GenericDatasource} from "@shared-datasource/generic.datasource";
import {UtilsService} from "@shared-services/utils.service";
import {
  CreateARetailerDialogComponent
} from "../create-a-retailer/create-a-lease-dialog/create-a-retailer-dialog.component";
import {RetailerViewComponent} from "../retailer-view/retailer-view.component";
import {Retailer, TenantType} from "../retailers.model";
import {RetailersService} from "../retailers.service";
import {ConsoleContextService} from "@security/console-context.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {CrudRetailerContacts} from '@features/leads/retailers/retailers-list/retailer-contacts.model';

@Component({
  selector: 'app-retailers-list',
  templateUrl: './retailers-list.component.html',
})
export class RetailersListComponent extends BasePageComponent implements OnInit {
  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = ['id', 'companyName', 'retailer', 'website', 'socialLink', 'email', 'tenantType', 'curationStatus'];
  dataSource = new GenericDatasource<Retailer>(this.retailersService);
  crudTableData: CrudRetailerContacts[] = [];

  constructor(injector: Injector,
              public utils: UtilsService,
              public context: ConsoleContextService,
              private tabService: TabManagementService,
              private retailersService: RetailersService,
              public loader: LoadingService,
              private matDialog: MatDialog) {
    super(injector)
  }

  protected readonly CrudRetailer = CrudRetailerContacts;

  ngOnInit() {
    this.retailersService.getAll()
      .subscribe({
        next: data => {
          this.crudTableData = data;
          this.crudTableData.forEach((row: CrudRetailerContacts) => {
            row.retailerName = row.ownerFirstname + " " + row.ownerLastname;
          });
        },
        error: error => {
          console.error(error);
        }
      });

  }

  openRetailerViewTab(id: string, companyName: string, tenantType: TenantType) {
    let payload: PageEventInterface = {
      componentToRegister: RetailerViewComponent,
      pageName: 'Retailer ' + id,
      pageHeader: this.offering!.label,
      data: { id: id, companyName: companyName, tenantType: tenantType },
      id: this.utils.generateUuidWithPrefix('retailer'),
      offeringId: this.offering!.offeringUuid,
      sectionCode: 'leads',
      pageCode: 'retailer',
      offering: this.offering
    }
    this.tabService.sendPageAddEvent(payload);
  }

  openCreateRetailer(): void {
    this.matDialog.open(CreateARetailerDialogComponent, {
      panelClass: 'dialog-large',
      data: {
        edit: false,
        lease: null,
        header: 'Create a new retailer',
        offering: this.offering,
        openRetailerInNewTab: true
      }
    })
  }


  retailerSelectedForView($event: any): void {
    if ($event) {
      const selectedRetailer = ($event as Retailer);
      this.openRetailerViewTab(selectedRetailer.id!.toString(), selectedRetailer.companyName, selectedRetailer.tenantType);
    }
  }

  protected readonly TenantType = TenantType;

}
